module.exports = __webpack_public_path__ + "icons/original/small/small-a6.b74ac4a06b9b99cdebadc188e6f2eba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-a6.png
// module id = pqg3
// module chunks = app